import React from "react";

import { commonMessages } from "infrastructure/localization";
import { ErrorContent } from "ui/components";
import { useLocalizedValues } from "ui/hooks";

export const NotFound: React.FC = () => {
  const localizedValues = useLocalizedValues(() => ({
    errorText: commonMessages.error("pageNotFound")
  }));

  return <ErrorContent text={localizedValues.errorText} />;
};
